"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDaysInAWeek = exports.getNextDate = exports.getPreviousDate = exports.getEndDate = exports.getStartDate = void 0;
const addDays_1 = __importDefault(require("date-fns/addDays"));
const addMonths_1 = __importDefault(require("date-fns/addMonths"));
const addWeeks_1 = __importDefault(require("date-fns/addWeeks"));
const addYears_1 = __importDefault(require("date-fns/addYears"));
const eachDayOfInterval_1 = __importDefault(require("date-fns/eachDayOfInterval"));
const endOfDay_1 = __importDefault(require("date-fns/endOfDay"));
const endOfMonth_1 = __importDefault(require("date-fns/endOfMonth"));
const endOfWeek_1 = __importDefault(require("date-fns/endOfWeek"));
const endOfYear_1 = __importDefault(require("date-fns/endOfYear"));
const startOfDay_1 = __importDefault(require("date-fns/startOfDay"));
const startOfMonth_1 = __importDefault(require("date-fns/startOfMonth"));
const startOfWeek_1 = __importDefault(require("date-fns/startOfWeek"));
const startOfYear_1 = __importDefault(require("date-fns/startOfYear"));
const subDays_1 = __importDefault(require("date-fns/subDays"));
const subMonths_1 = __importDefault(require("date-fns/subMonths"));
const subWeeks_1 = __importDefault(require("date-fns/subWeeks"));
const subYears_1 = __importDefault(require("date-fns/subYears"));
const calendar_mode_1 = require("./calendar-mode");
/**
 * Gets the start date based on mode
 * @param selectedDate - User selected date
 * @param mode - Calendar mode
 * @returns - Date
 */
exports.getStartDate = (selectedDate, mode) => {
    switch (mode) {
        case calendar_mode_1.CalendarModeEnum.DAY:
            return startOfDay_1.default(selectedDate);
        case calendar_mode_1.CalendarModeEnum.WEEK:
            return startOfWeek_1.default(selectedDate);
        case calendar_mode_1.CalendarModeEnum.MONTH:
            return startOfMonth_1.default(selectedDate);
        case calendar_mode_1.CalendarModeEnum.YEAR:
            return startOfYear_1.default(selectedDate);
        default:
            return startOfDay_1.default(selectedDate);
    }
};
/**
 * Gets the end date based on mode
 * @param selectedDate - User selected date
 * @param mode - Calendar mode
 * @returns - Date
 */
exports.getEndDate = (selectedDate, mode) => {
    switch (mode) {
        case calendar_mode_1.CalendarModeEnum.DAY:
            return endOfDay_1.default(selectedDate);
        case calendar_mode_1.CalendarModeEnum.WEEK:
            return endOfWeek_1.default(selectedDate);
        case calendar_mode_1.CalendarModeEnum.MONTH:
            return endOfMonth_1.default(selectedDate);
        case calendar_mode_1.CalendarModeEnum.YEAR:
            return endOfYear_1.default(selectedDate);
        default:
            return endOfDay_1.default(selectedDate);
    }
};
/**
 * Gets the previous date based on current date with respective to mode
 * @param currentDate - Current date set
 * @param mode - Calendar Mode
 * @returns - Date
 */
exports.getPreviousDate = (currentDate, mode) => {
    switch (mode) {
        case calendar_mode_1.CalendarModeEnum.DAY:
            return subDays_1.default(currentDate, 1);
        case calendar_mode_1.CalendarModeEnum.WEEK:
            return subWeeks_1.default(currentDate, 1);
        case calendar_mode_1.CalendarModeEnum.MONTH:
            return subMonths_1.default(currentDate, 1);
        case calendar_mode_1.CalendarModeEnum.YEAR:
            return subYears_1.default(currentDate, 1);
        default:
            return subDays_1.default(currentDate, 1);
    }
};
/**
 * Gets the next date based on current date with respective to mode
 * @param currentDate - Current date set
 * @param mode - Calendar Mode
 * @returns - Date
 */
exports.getNextDate = (currentDate, mode) => {
    switch (mode) {
        case calendar_mode_1.CalendarModeEnum.DAY:
            return addDays_1.default(currentDate, 1);
        case calendar_mode_1.CalendarModeEnum.WEEK:
            return addWeeks_1.default(currentDate, 1);
        case calendar_mode_1.CalendarModeEnum.MONTH:
            return addMonths_1.default(currentDate, 1);
        case calendar_mode_1.CalendarModeEnum.YEAR:
            return addYears_1.default(currentDate, 1);
        default:
            return addDays_1.default(currentDate, 1);
    }
};
/**
 * Gets all the days in a week. If no date is passed returns SUN - SAT
 * @param date - If any date is specified it returns that week the date belongs
 * @returns - Array of dates
 */
exports.getDaysInAWeek = (date) => {
    const start = startOfWeek_1.default(date || new Date());
    const end = endOfWeek_1.default(date || new Date());
    return eachDayOfInterval_1.default({ start, end });
};
//# sourceMappingURL=data:application/json;base64,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